import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'styles/notFound.css'; // Assurez-vous d'importer le fichier CSS

const NotFound: React.FC = () => {
  /**
   * CONTEXT
   */
  const navigate = useNavigate();
  return (
    <div className='not-found-container'>
      <h1>404</h1>
      <p>La page que vous recherchez est introuvable.</p>
      <button onClick={() => navigate('/')}>Retour à l'accueil</button>
    </div>
  );
};

export default NotFound;
